<template>
  <div>
    <v-data-table
      class="data__table wardens-table"
      ref="table"
      :headers="headers"
      :items="connections"
      fixed-header
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="mobileBreakpoint"
    >
      <template v-slot:item.integrator_id="{ item }">
        {{ anprName(item) }}
      </template>
      <template v-slot:item.start="{ item }">
        {{ featureNameStart(item.start) }}
      </template>
      <template v-slot:item.stop="{ item }">
        {{ featureNameStop(item.stop) }}
      </template>
      <template v-slot:item.location_id="{ item }">
        <div class="mobile-row__action d-flex justify-end">
          <v-btn
              class="pkmn-button pkmn-button--no-padding"
              text
              color="warning"
              @click="showConfirmDeleteAnprPopup(item)"
            >
              <img src="@/assets/button-delete.svg" />
            </v-btn>
        </div>
      </template>
    </v-data-table>
    <form-delete-anpr
      v-if="showDeleteAnprPopup === true"
      @close="showDeleteAnprPopup = false"
      @delete="deleteAnpr"
    />
  </div>
</template>

<script>
import auth from '@/auth'
import FormDeleteAnpr from './FormDeleteAnpr.vue'
export default {
  name: 'SubtabCamera',
  components: {
    FormDeleteAnpr
   },
  props: {
    connections: {
      type: Array,
      default: () => []
    },
    anprConfig: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      auth: auth,
      headers: [
        { text: 'ANPR system', value: 'integrator_id' },
        { text: 'Start parking', value: 'start' },
        { text: 'Stop parking', value: 'stop' },
        { text: 'ANPR code', value: 'integrator_location_code' },
        { text: '', value: 'location_id', sortabl: false }
      ],
      mobileBreakpoint: 767,
      showDeleteAnprPopup: false
    }
  },
  computed: {
  },
  methods: {
    showConfirmDeleteAnprPopup(record) {
      this.showDeleteAnprPopup = true
    },
    anprName(record) {
      if (this.anprConfig === null) {
        return record.integrator_id
      } else {
        const integrator = this.anprConfig.integrators.find(item => item.id === record.integrator_id)
        return integrator ? this.capitalize(integrator.name) : record.integrator_id
      }
    },
    featureNameStart(names) {
      const mapping = {
      'camera_manual_start': 'Manual',
      'camera_auto_start': 'Automatic'
      }
      return names
      .map(id => mapping[id])
      .filter(Boolean)
      .join(', ')
    },
    featureNameStop(name) {
      if (name === 'camera_auto_stop') {
        return 'Automatic'
      } 
    },
    deleteAnpr(record) {
      this.$emit('deleteAnpr')
    },
    capitalize(word) {
      return word.charAt(0).toUpperCase() + word.slice(1)
    }
  }
}
</script>

<style lang="scss" scoped>

.wardens-table {
  &-chip {
    height: 12px;
    font-size: 10px;
  }
  .mobile-row__action {
    .theme--light:focus:before {
      opacity: 1 !important;
    }
  }
}

.add-row {
  border-top: 1px solid #eee;
  
  &:hover {
    background-color: #f8f8f8;
  }
}

.add-row__text {
  color: #333333;  /* Primary color */
  font-weight: 400;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
}
.delete-button {
  margin-right: 16px;
}
</style>
